var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCookies = function SvgCookies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "M19.203 9.592a3 3 0 0 1-3.004-3.02 2.98 2.98 0 0 1-3.229.258A3.003 3.003 0 0 1 11.635 3a9.004 9.004 0 1 0 8.94 6.25c-.424.222-.894.34-1.372.342"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "M8.373 12.592a1.802 1.802 0 1 0 0-3.605 1.802 1.802 0 0 0 0 3.605M13.782 17.4a1.202 1.202 0 1 0 0-2.404 1.202 1.202 0 0 0 0 2.403"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeWidth: "inherit",
    d: "M8.074 16.198a.3.3 0 0 1 0-.601M8.074 16.198a.3.3 0 0 0 0-.601M12.88 10.79a.3.3 0 0 1 0-.601"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeWidth: "inherit",
    d: "M12.879 10.79a.3.3 0 0 0 0-.601M17.687 13.194a.3.3 0 1 1 0-.6M17.688 13.194a.3.3 0 1 0 0-.6"
  })));
};
export default SvgCookies;